import { render, staticRenderFns } from "./DriveEditModal.vue?vue&type=template&id=2afa7379&"
import script from "./DriveEditModal.vue?vue&type=script&lang=ts&"
export * from "./DriveEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports